export default __webpack_public_path__ + "static/media/douzhuan.691744ef.png";